import React from 'react';
import { PopupOrPanel } from '../../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  backToProfilePage: any;
  unableToSyncTitle: string;
  unableToSyncMsg: string;
};

export const UnableToSyncDataPopup: React.FC<Props> = ({
  panelOpen,
  backToProfilePage,
  unableToSyncTitle,
  unableToSyncMsg,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={unableToSyncTitle}
      position="right"
      givenClass="WondeSyncData"
      noFooter={false}
      primaryBtnTxt="Close"     
      handleClose={() => backToProfilePage()}
      handlePrimaryBtn={() => backToProfilePage()}
      width={460}
    >
      <p>{unableToSyncMsg}</p>
    </PopupOrPanel>
  );  
};